import axios from 'axios';
import { acquireAccessToken } from '../msal/_utilities';
import msalConfig from '../msal/config';
import apiConfig from './config/config';

const instance = axios.create(apiConfig);

instance.interceptors.request.use(
	async config => {
		const token = await acquireAccessToken(msalConfig.requests.api);

		config.headers.Authorization = `Bearer ${token}`;

		return config;
	},
	function (err) {
		return Promise.reject(err);
	}
);

export default instance;
